import React from 'react'

const IconReviewStar: React.FunctionComponent = () => {
  return <>
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M19.948 7.628a1.06 1.06 0 0 0-.915-.726L13.26 6.38l-2.282-5.312a1.063 1.063 0 0 0-1.955.001L6.74 6.38l-5.773.522a1.062 1.062 0 0 0-.915.726c-.131.403-.01.845.311 1.123l4.364 3.805-1.287 5.636c-.094.414.067.842.413 1.09a1.065 1.065 0 0 0 1.168.052l4.98-2.96 4.977 2.96c.364.217.823.198 1.168-.051.346-.25.508-.678.413-1.091l-1.286-5.636 4.363-3.804c.321-.28.444-.72.312-1.124Z" fill="#FFD100" /></svg>
  </>
}

export default IconReviewStar